export const InputSizes = {
  SM: 'sm',
  LG: 'lg',
};

export const SelectSizes = {
  DEFAULT: 'default',
  LARGE: 'large',
};

export const SelectTabKinds = {
  PRIMARY: 'primary',
  NEGATIVE: 'negative',
  GRAY: 'gray',
};

export const SelectToggleModes = {
  SELECT: 'select',
  SEARCH: 'search',
};

export const hideField = {
  meta: { valueGetter: () => '' },
  additionalProps: { hidden: true },
};
